import React from 'react'

export default function ShareSelectedTheme(props) {
	const { themeconfig } = props
	const handleText = (item) => {

		// here pass the item to the parent and make the item as selected
		// call the parent function ()
		// props.callParentFunction()
	}
	return (
		//Here map the themeConfig data and display them as boxes
		<div>
			{/* Here dispaly the number of blocks  */}
			{/* for each text text input add a handle funciton to save the enter text */}

		</div>
	)
}
